import './UnauthenticatedLayout.css'

import React from 'react'
import { useTranslation } from 'react-i18next'

import { useIsMaintenanceModeEnabled } from '../../../data/tenants'
import { MaintenanceScreen } from '../../../features/maintenance'
import { DocumentTitle } from '../../DocumentTitle'
import { LoginButton } from '../../auth'
import { Footer } from './Footer'

const UnauthenticatedLayout: React.FC = () => {
  const { t } = useTranslation()
  const { data: isMaintenanceModeEnabled } = useIsMaintenanceModeEnabled()

  if (isMaintenanceModeEnabled) return <MaintenanceScreen />
  return (
    <>
      <DocumentTitle title={t('login.page.title')} />

      {/* Background */}
      <div
        className="background flex flex-column md:justify-content-center align-items-center"
        style={{
          backgroundImage: 'url(/assets/images/background-joubini.jpg)',
        }}
      >
        {/* Login card */}
        <div className="login-card flex flex-column align-items-center border-round-3xl pt-5 px-5 pb-8 mb-5">
          {/* NTT DATA logo */}
          <div className="w-full">
            <img src="/assets/images/logo-ndbs.svg" alt="company" height="26" />
          </div>

          <img
            src="/assets/images/logo-webedi.png"
            alt="company"
            height="70"
            className="mt-7"
          />

          <h1 className="welcome-title text-xxl lg:text-5xl line-height-2 text-center text-white mb-6">
            {t('login.content.body.title')}
          </h1>

          <LoginButton isMaintenanceActive={isMaintenanceModeEnabled!} />
        </div>

        {/* Footer */}
        <div className="footer w-full flex justify-content-center md:justify-content-start md:absolute flex-order-2">
          <Footer />
        </div>

        {/* By NTT DATA */}
        <div className="by-ntt-data block md:absolute mb-4 md:mb-0 flex-order-1">
          <img
            alt="Integration platform Joubini by NTT Data"
            src={
              process.env.PUBLIC_URL + '/assets/images/logo-joubini-by-ndbs.svg'
            }
            height="60"
          />
        </div>
      </div>
    </>
  )
}

export default UnauthenticatedLayout
